import React from "react";

import { cn } from "../../../ui";
import dosee_logo from "../../../../assets/images/dosee.png";

type FormWidth = "md" | "lg";

type Props = {
  children: React.ReactNode;
  eyebrow?: string;
  formWidth?: FormWidth;
};

const FORM_WIDTHS: Record<FormWidth, string> = {
  md: "max-w-md",
  lg: "max-w-lg",
};

const AuthShell: React.FC<Props> = ({
  children,
  eyebrow = "Admin Console",
  formWidth = "md",
}) => (
  <div className="flex min-h-screen w-full bg-white text-gray-900">
    <aside className="relative hidden w-1/2 flex-col overflow-hidden bg-gray-50 px-10 py-12 lg:flex xl:w-[46%] xl:px-16">
      <div
        aria-hidden
        className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full bg-brand/10 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-40 -right-32 h-[420px] w-[420px] rounded-full bg-brand/[0.06] blur-3xl"
      />

      <div className="relative flex items-center gap-3">
        <img src={dosee_logo} alt="DoseeAfrica" className="h-8 w-auto" />
        <span className="text-[13px] font-semibold tracking-tight text-gray-900">
          DoseeAfrica
        </span>
      </div>

      <div className="relative my-auto max-w-[460px]">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-[10.5px] font-semibold uppercase tracking-[0.14em] text-gray-600 ring-1 ring-inset ring-gray-200">
          <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-brand" />
          {eyebrow}
        </span>

        <h2 className="mt-7 text-[42px] font-semibold leading-[1.05] tracking-tight text-gray-900">
          Africa’s tourism, <span className="text-brand">curated</span> from
          here.
        </h2>

        <p className="mt-6 text-[15px] leading-relaxed text-gray-600">
          The admin console where operators, curators and reviewers shape
          travel experiences across the continent — from a single place.
        </p>

        <div className="mt-10 flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.14em] text-gray-500">
          <span aria-hidden className="h-px w-10 bg-gray-300" />
          Encrypted · Audited · Trusted
        </div>
      </div>

      <div className="relative flex items-center justify-between text-[11px] text-gray-500">
        <span>© {new Date().getFullYear()} DoseeAfrica</span>
        <span className="inline-flex items-center gap-2">
          <span
            aria-hidden
            className="h-1.5 w-1.5 rounded-full bg-emerald-500"
          />
          All systems operational
        </span>
      </div>
    </aside>

    <main className="relative flex flex-1 items-center justify-center px-5 py-10 sm:px-8 lg:px-12">
      <div className={cn("w-full", FORM_WIDTHS[formWidth])}>{children}</div>
    </main>
  </div>
);

export default AuthShell;
